"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const classnames_1 = __importDefault(require("classnames"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle/DialogTitle"));
const Paper_1 = __importDefault(require("@mui/material/Paper/Paper"));
const Button_1 = __importDefault(require("@mui/material/Button/Button"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const DateField_1 = __importDefault(require("components/QuickenControls/DateField"));
const AmountField_1 = __importStar(require("components/QuickenControls/AmountField"));
const ReconcileSetup = ({ onClose, onSave, classes, isOnline, account, lastReconciledBalance, }) => {
    const [state, setState] = (0, react_1.useState)({
        useOnline: isOnline,
        statementEndBalance: isOnline ? Number(account.onlineBalance) : '',
        statementEndDate: isOnline ? account.onlineBalanceAt : luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    });
    const handleChange = (e, field) => {
        switch (field) {
            case 'postedOn':
                if (e) {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { statementEndDate: e.target.value })));
                }
                break;
            case 'useOnline':
                setState((prevState) => (Object.assign(Object.assign({}, prevState), { useOnline: !state.useOnline })));
                break;
            case 'amount':
            default:
                if (e) {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { [field]: e.target.value })));
                }
                break;
        }
    };
    const saveFn = () => {
        onSave(state);
    };
    const closeAndExit = () => {
        onClose();
    };
    return (<Dialog_1.default classes={{ paperWidthXs: classes.paperWidthSm }} open maxWidth="xs" onClose={closeAndExit} onKeyDown={(e) => e.stopPropagation()}>
      <DialogTitle_1.default>Reconcile Transactions</DialogTitle_1.default>
      <div>
        {isOnline &&
            <FormGroup_1.default>
            <FormControlLabel_1.default classes={{ label: classes.labelBold }} control={<Switch_1.default checked={state.useOnline} onChange={(e) => handleChange(e, 'useOnline')} value="useOnline" color="primary"/>} label={`Use Online Balance: ${(0, AmountField_1.formatNumber)(account.onlineBalance, account.currency, '0,0.00')}`}/>
          </FormGroup_1.default>}

        <Divider_1.default />
        <FormGroup_1.default classes={{ root: classes.formGroup }}>
          {!state.useOnline &&
            <FormControlLabel_1.default classes={{ root: (0, classnames_1.default)(classes.formControlLabel, 'bottomSpace') }} control={<div className={classes.divFormControlLabel}>
                  <AmountField_1.default autoFocus amountType="amount" editable={false} value={String(lastReconciledBalance)} currencySymbol={account.currency} className={state.useOnline ? classes.inputFieldsBold : classes.inputFields} maxChars={16} // support balances under 10 billion (with decimal and 2 decimal points)
                >
                  </AmountField_1.default>
                </div>} label="Previous Reconciled Balance:" labelPlacement="start"/>}
          <FormControlLabel_1.default classes={{ root: (0, classnames_1.default)(classes.formControlLabel, 'bottomSpace') }} control={<div className={classes.divFormControlLabel}>
                <AmountField_1.default autoFocus amountType="amount" onChange={(e) => handleChange(e, 'statementEndBalance')} editable={!state.useOnline} value={String(state.statementEndBalance)} currencySymbol={account.currency} className={state.useOnline ? classes.inputFieldsBold : classes.inputFields}>
                </AmountField_1.default>
              </div>} label="Statement Ending Balance:" labelPlacement="start"/>
          <FormControlLabel_1.default classes={{ root: classes.formControlLabel }} control={<div className={classes.divFormControlLabel}>
                <DateField_1.default fieldId="postedOn" editable={!state.useOnline} value={state.statementEndDate} onChange={(e) => handleChange(e, 'postedOn')} todaysDateIfWrong customStyle={{ marginLeft: 10, fontWeight: state.useOnline ? 800 : null, fontSize: '16px' }}/>
              </div>} label="Statement Ending Date:" labelPlacement="start"/>
        </FormGroup_1.default>
      </div>

      <Divider_1.default />
      <Typography_1.default variant="body2">
        Note: If there are any older unreconciled transactions on the desktop client that have not been synced,
        they are not considered for reconciliation
      </Typography_1.default>
      <Divider_1.default />
      <Paper_1.default elevation={0} className={classes.buttonHolder}>
        <div className={classes.divFlexFull}/>
        <Button_1.default className={classes.buttons} onClick={closeAndExit} color="primary" id="bulk-edit-cancel">
          Cancel
        </Button_1.default>
        <Button_1.default className={classes.buttons} onClick={saveFn} name="bulk-edit-last-tab" color="primary" id="bulk-edit-save">
          Next
        </Button_1.default>
      </Paper_1.default>
    </Dialog_1.default>);
};
exports.default = ReconcileSetup;
